import React, { useState } from "react";
import UserAvatar from "./UserAvatar";
import UserDropdown from "./UserDropdown";
import {
  GroupCellWrapper,
  GroupEmptyWrapper,
  GroupEmptyLabel,
  GroupRow,
  OverflowBubble,
} from "./Avatar.styled";

/**
 * Avatar group cell — shows stacked avatars with a "+N" overflow bubble
 * and a searchable dropdown. Replaces AssignedToCell / AssignedByCell /
 * AuditorsCell with a single generic component.
 *
 * @param {Array}   users          — [{ id, name, first_name, last_name, email, meta }]
 * @param {number}  [maxVisible=3] — max avatars before overflow
 * @param {string}  [emptyLabel]   — text when list is empty
 * @param {number}  [width=150]    — cell width in px
 */
const AvatarGroup = ({
  users,
  maxVisible = 3,
  emptyLabel = "Unassigned",
  width = 150,
  isError = false,
}) => {
  const [open, setOpen] = useState(false);
  const list = Array.isArray(users) ? users : [];
  const visible = list.slice(0, maxVisible);
  const extra = list.length - maxVisible;

  if (!list.length) {
    return (
      <GroupEmptyWrapper $width={width}>
        <GroupEmptyLabel $isError={isError}>{emptyLabel}</GroupEmptyLabel>
      </GroupEmptyWrapper>
    );
  }

  return (
    <GroupCellWrapper $width={width} onMouseLeave={() => setOpen(false)}>
      <GroupRow>
        {visible.map((u, i) => (
          <UserAvatar key={u.id} user={u} overlap={i > 0} />
        ))}
        {extra > 0 && (
          <OverflowBubble onMouseEnter={() => setOpen(true)}>
            +{extra}
          </OverflowBubble>
        )}
      </GroupRow>
      <UserDropdown
        users={list}
        open={open}
        onClose={() => setOpen(false)}
      />
    </GroupCellWrapper>
  );
};

export default AvatarGroup;
